<template>
    <div>
     <NavBar />
     <AboutHero />
     <OurStory />
     <OurValues />
     <FooterPage />
    </div>
</template>

<script>
//import HeroPage from '../components/HeroPage.vue'
import NavBar from '../components/NavBar.vue'
import AboutHero from '../components/AboutHero.vue'
import OurStory from '../components/OurStory.vue'
import FooterPage from '../components/FooterPage.vue'
import OurValues from '../components/OurValues.vue'


export default {
  name: 'HomePage',
  components: {
    NavBar, AboutHero, OurStory, FooterPage, OurValues
  }
}
</script>